import React, { useState } from "react";
import Button from "../Forms/Button";
import classes from "./FileHandler.module.css";
import {
  Constants,
  Activity,
  currentRequestTimeStamp,
} from "../../../Constants";
import { toast } from "react-toastify";
import axios from "axios";
import { Urls } from "../../../Urls";
import { useAppContext, ContextConstants } from "../../../Context/AppContext";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import mixpanel from "mixpanel-browser";
import { useAzureUpload } from "../../../hooks/useAzureFileUpload";
import {
  DownloadFile,
  getSignedDownloadUrl,
} from "../../../shared_utilities/fileDownloadUtils";
import { Document, Page } from "react-pdf";  // Import react-pdf
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const FileHandler = ({
  onUpload,
  fileId,
  transporterId,
  className,
  lastUpdated,
  fileViewHeader = "",
  fileName,
  lastUpdatedClassName,
  lastUpdatedAtBottom,
  fileDescription = "",
  screen = "",
  modulename = "",
  title,
  onViewFile,
}) => {
  const { dispatch } = useAppContext();
  const [viewFile, setViewFile] = useState(false);
  const [viewFilePath, setViewFilePath] = useState();
  const { transporterInfo } = useAppContext();
  const [numPages, setNumPages] = useState(null); // Track number of pages
  const [loading, setLoading] = useState(true); // Loading state for the PDF

  const { uploadFile } = useAzureUpload();

  const onLoaderStateChange = () =>
    dispatch({
      type: ContextConstants.ToggleLoaderState,
    });

  const trackMixpanel = () => {
    return mixpanel.track(
      `User has clicked on ${title === "Turnover"
        ? "Balance"
        : title === "Net Profit"
          ? "PNL"
          : title === "Owned Fleet"
            ? "Owned fleet"
            : title === "profile"
              ? "Profile"
              : title === "branches"
                ? "Branches"
                : title === "operatingLanes"
                  ? "Operating Lanes"
                  : title === "warehousingHubs"
                    ? "Warehousing Hubs"
                    : title === "backhaulLanes"
                      ? "Backhaul Lanes"
                      : title === "other"
                        ? "other"
                        : title === "Partnership Deed"
                          ? "Partnership Deed"
                          : title === "Certificate of Incorporation(COI)"
                            ? "Certificate of Incorporation(COI)"
                            : title === "Cancelled Cheque"
                              ? "Cancelled Cheque"
                              : title === "Board Resolution"
                                ? "Board Resolution"
                                : "other"
      } sheet upload button`,
      {
        // distinct_id: 'unique client id',
        ApplicationName: `${Urls.appnamemixpanel}`,
        ScreenName: "Transporter-Profile",
        ModuleName: `${modulename === "Financial Information" || modulename === "Attachments"
          ? "general-information-edit"
          : "contract-closure-edit"
          }`,
        ActivityLog: `${title === "Turnover"
          ? "userClickedBalanceSheetUploadButton"
          : title === "Net Profit"
            ? "userClickedPnLStatementUploadButton"
            : title === "Owned Fleet"
              ? "userClickedOwnedFleetDownloadButton"
              : title === "profile"
                ? "userClickedAttachmentProfileUploadButton"
                : title === "branches"
                  ? "userClickedAttachmentBranchesUploadButton"
                  : title === "operatingLanes"
                    ? "userClickedAttachmentOperatingLanesUploadButton"
                    : title === "warehousingHubs"
                      ? "userClickedAttachmentWarehousingHubUploadButton"
                      : title === "backhaulLanes"
                        ? "userClickedAttachmentBackhaulLanesUploadButton"
                        : title === "other"
                          ? "userClickedAttachmentOthersUploadButton"
                          : title === "Partnership Deed"
                            ? "userClickedAttachmentPartnershipDeedUploadButton"
                            : title === "Certificate of Incorporation(COI)"
                              ? "userClickedAttachmentCertificateOfIncorporationUploadButton"
                              : title === "Cancelled Cheque"
                                ? "userClickedAttachmentCancelledChequeUploadButton"
                                : title === "Board Resolution"
                                  ? "userClickedAttachmentBoardResolutionUploadButton"
                                  : "NA"
          }`,
        Data: `${title === "Turnover"
          ? `${fileName}`
          : title === "Net Profit"
            ? `${fileName}`
            : title === "Owned Fleet"
              ? `${fileName}`
              : title === "profile"
                ? `${fileName}`
                : title === "branches"
                  ? `${fileName}`
                  : title === "operatingLanes"
                    ? `${fileName}`
                    : title === "warehousingHubs"
                      ? `${fileName}`
                      : title === "backhaulLanes"
                        ? `${fileName}`
                        : title === "other"
                          ? `${fileName}`
                          : title === "Partnership Deed"
                            ? `${fileName}`
                            : title === "Certificate of Incorporation(COI)"
                              ? `${fileName}`
                              : title === "Cancelled Cheque"
                                ? `${fileName}`
                                : title === "Board Resolution"
                                  ? `${fileName}`
                                  : "NA"
          }`,
        Definition: `User has clicked on ${title === "Turnover"
          ? "Balance"
          : title === "Net Profit"
            ? "PNL"
            : title === "Owned Fleet"
              ? "Owned fleet"
              : title === "profile"
                ? "Profile"
                : title === "branches"
                  ? "Branches"
                  : title === "operatingLanes"
                    ? "Operating Lanes"
                    : title === "warehousingHubs"
                      ? "Warehousing Hubs"
                      : title === "backhaulLanes"
                        ? "Backhaul Lanes"
                        : title === "other"
                          ? "other"
                          : title === "Partnership Deed"
                            ? "Partnership Deed"
                            : title === "Certificate of Incorporation(COI)"
                              ? "Certificate of Incorporation(COI)"
                              : title === "Cancelled Cheque"
                                ? "Cancelled Cheque"
                                : title === "Board Resolution"
                                  ? "Board Resolution"
                                  : "other"
          } sheet upload button`,
        TransporterName: transporterInfo.transporter_name,
        TransporterId: transporterInfo.transporterId,
        ActivityType: "event_view",
      }
    );
  };

  const onChange = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (!validateFile(file)) {
      e.target.value = null;
      return;
    }

    try {
      Activity([
        {
          screen,
          module: modulename,
          user_activity: `${fileDescription}_${file.name}_upload`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);

      trackMixpanel();
      onLoaderStateChange();

      const { blobUrl, fileName } = await uploadFile(
        file,
        `${transporterId}_${file.name}`
      );

      onUpload(fileName, file.name);
      toast.success("File uploaded successfully");
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error("File upload failed");
    } finally {
      onLoaderStateChange();
    }
  };

  const onDownload = async () => {
    try {

      trackMixpanel();

      Activity([
        {
          screen,
          module: modulename,
          user_activity: `${fileDescription}_download`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);

      mixpanel.track(
        `User has clicked on ${title === "Turnover"
          ? "Balance"
          : title === "Net Profit"
            ? "PNL"
            : title === "Owned Fleet"
              ? "Owned fleet"
              : title === "profile"
                ? "Profile"
                : title === "branches"
                  ? "Branches"
                  : title === "operatingLanes"
                    ? "Operating Lanes"
                    : title === "warehousingHubs"
                      ? "Warehousing Hubs"
                      : title === "backhaulLanes"
                        ? "Backhaul Lanes"
                        : title === "other"
                          ? "other"
                          : title === "Partnership Deed"
                            ? "Partnership Deed"
                            : title === "Certificate of Incorporation(COI)"
                              ? "Certificate of Incorporation(COI)"
                              : title === "Cancelled Cheque"
                                ? "Cancelled Cheque"
                                : title === "Board Resolution"
                                  ? "Board Resolution"
                                  : "other"
        } sheet download button`,
        {
          // distinct_id: 'unique client id',
          ApplicationName: `${Urls.appnamemixpanel}`,
          ScreenName: "Transporter-Profile",
          ModuleName: `${modulename === "Financial Information" ||
            modulename === "Attachments"
            ? "general-information"
            : "contract-closure"
            }`,
          ActivityLog: `${title === "Turnover"
            ? "userClickedBalanceSheetDownloadButton"
            : title === "Net Profit"
              ? "userClickedPnLStatementDownloadButton"
              : title === "Owned Fleet"
                ? "userClickedOwnedFleetDownloadButton"
                : title === "profile"
                  ? "userClickedAttachmentProfileDownloadButton"
                  : title === "branches"
                    ? "userClickedAttachmentBranchesDownloadButton"
                    : title === "operatingLanes"
                      ? "userClickedAttachmentOperatingLanesDownloadButton"
                      : title === "warehousingHubs"
                        ? "userClickedAttachmentWarehousingHubDownloadButton"
                        : title === "backhaulLanes"
                          ? "userClickedAttachmentBackhaulLanesDownloadButton"
                          : title === "other"
                            ? "userClickedAttachmentOthersDownloadButton"
                            : title === "Partnership Deed"
                              ? "userClickedAttachmentPartnershipDeedDownloadButton"
                              : title === "Certificate of Incorporation(COI)"
                                ? "userClickedAttachmentCertificateOfIncorporationDownloadButton"
                                : title === "Cancelled Cheque"
                                  ? "userClickedAttachmentCancelledChequeDownloadButton"
                                  : title === "Board Resolution"
                                    ? "userClickedAttachmentBoardResolutionDownloadButton"
                                    : "NA"
            }`,
          Data: `${title === "Turnover"
            ? `${fileName}`
            : title === "Net Profit"
              ? `${fileName}`
              : title === "Owned Fleet"
                ? `${fileName}`
                : title === "profile"
                  ? `${fileName}`
                  : title === "branches"
                    ? `${fileName}`
                    : title === "operatingLanes"
                      ? `${fileName}`
                      : title === "warehousingHubs"
                        ? `${fileName}`
                        : title === "backhaulLanes"
                          ? `${fileName}`
                          : title === "other"
                            ? `${fileName}`
                            : title === "Partnership Deed"
                              ? `${fileName}`
                              : title === "Certificate of Incorporation(COI)"
                                ? `${fileName}`
                                : title === "Cancelled Cheque"
                                  ? `${fileName}`
                                  : title === "Board Resolution"
                                    ? `${fileName}`
                                    : "NA"
            }`,
          Definition: `User has clicked on ${title === "Turnover"
            ? "Balance"
            : title === "Net Profit"
              ? "PNL"
              : title === "Owned Fleet"
                ? "Owned fleet"
                : title === "profile"
                  ? "Profile"
                  : title === "branches"
                    ? "Branches"
                    : title === "operatingLanes"
                      ? "Operating Lanes"
                      : title === "warehousingHubs"
                        ? "Warehousing Hubs"
                        : title === "backhaulLanes"
                          ? "Backhaul Lanes"
                          : title === "other"
                            ? "other"
                            : title === "Partnership Deed"
                              ? "Partnership Deed"
                              : title === "Certificate of Incorporation(COI)"
                                ? "Certificate of Incorporation(COI)"
                                : title === "Cancelled Cheque"
                                  ? "Cancelled Cheque"
                                  : title === "Board Resolution"
                                    ? "Board Resolution"
                                    : "other"
            } sheet download button`,
          TransporterName: transporterInfo.transporter_name,
          TransporterId: transporterInfo.transporterId,
          ActivityType: "event_view",
        }
      );

      await DownloadFile(fileId, onLoaderStateChange, fileName);
    } catch (err) {
      console.error("Download failed:", err);
      toast.error("File download failed");
    }
  };

  const isViewableFile = (name) => {
    const ext = (name || "").split(".").pop()?.trim().toLowerCase();
    return ["pdf", "png", "jpg", "jpeg"].includes(ext);
  };

  const onViewClick = async () => {
    try {
      onLoaderStateChange();

      mixpanel.track(
        `User has clicked on ${title === "Turnover"
          ? "Balance"
          : title === "Net Profit"
            ? "PNL"
            : title === "Owned Fleet"
              ? "Owned fleet"
              : title === "profile"
                ? "Profile"
                : title === "branches"
                  ? "Branches"
                  : title === "operatingLanes"
                    ? "Operating Lanes"
                    : title === "warehousingHubs"
                      ? "Warehousing Hubs"
                      : title === "backhaulLanes"
                        ? "Backhaul Lanes"
                        : title === "other"
                          ? "other"
                          : title === "Partnership Deed"
                            ? "Partnership Deed"
                            : title === "Certificate of Incorporation(COI)"
                              ? "Certificate of Incorporation(COI)"
                              : title === "Cancelled Cheque"
                                ? "Cancelled Cheque"
                                : title === "Board Resolution"
                                  ? "Board Resolution"
                                  : "other"
        } sheet view button`,
        {
          // distinct_id: 'unique client id',
          ApplicationName: `${Urls.appnamemixpanel}`,
          ScreenName: "Transporter-Profile",
          ModuleName: `${modulename === "Financial Information" ||
            modulename === "Attachments"
            ? "general-information"
            : "contract-closure"
            }`,
          ActivityLog: `${title === "Turnover"
            ? "userClickedBalanceSheetViewButton"
            : title === "Net Profit"
              ? "userClickedPnLStatementViewButton"
              : title === "Owned Fleet"
                ? "userClickedOwnedFleetDownloadButton"
                : title === "profile"
                  ? "userClickedAttachmentProfileViewButton"
                  : title === "branches"
                    ? "userClickedAttachmentBranchesViewButton"
                    : title === "operatingLanes"
                      ? "userClickedAttachmentOperatingLanesViewButton"
                      : title === "warehousingHubs"
                        ? "userClickedAttachmentWarehousingHubViewButton"
                        : title === "backhaulLanes"
                          ? "userClickedAttachmentBackhaulLanesViewButton"
                          : title === "other"
                            ? "userClickedAttachmentOthersViewButton"
                            : title === "Partnership Deed"
                              ? "userClickedAttachmentPartnershipDeedViewButton"
                              : title === "Certificate of Incorporation(COI)"
                                ? "userClickedAttachmentCertificateOfIncorporationViewButton"
                                : title === "Cancelled Cheque"
                                  ? "userClickedAttachmentCancelledChequeViewButton"
                                  : title === "Board Resolution"
                                    ? "userClickedAttachmentBoardResolutionViewButton"
                                    : "NA"
            }`,
          Data: `${title === "Turnover"
            ? `${fileName}`
            : title === "Net Profit"
              ? `${fileName}`
              : title === "Owned Fleet"
                ? `${fileName}`
                : title === "profile"
                  ? `${fileName}`
                  : title === "branches"
                    ? `${fileName}`
                    : title === "operatingLanes"
                      ? `${fileName}`
                      : title === "warehousingHubs"
                        ? `${fileName}`
                        : title === "backhaulLanes"
                          ? `${fileName}`
                          : title === "other"
                            ? `${fileName}`
                            : title === "Partnership Deed"
                              ? `${fileName}`
                              : title === "Certificate of Incorporation(COI)"
                                ? `${fileName}`
                                : title === "Cancelled Cheque"
                                  ? `${fileName}`
                                  : title === "Board Resolution"
                                    ? `${fileName}`
                                    : "NA"
            }`,
          Definition: `User has clicked on ${title === "Turnover"
            ? "Balance"
            : title === "Net Profit"
              ? "PNL"
              : title === "Owned Fleet"
                ? "Owned fleet"
                : title === "profile"
                  ? "Profile"
                  : title === "branches"
                    ? "Branches"
                    : title === "operatingLanes"
                      ? "Operating Lanes"
                      : title === "warehousingHubs"
                        ? "Warehousing Hubs"
                        : title === "backhaulLanes"
                          ? "Backhaul Lanes"
                          : title === "other"
                            ? "other"
                            : title === "Partnership Deed"
                              ? "Partnership Deed"
                              : title === "Certificate of Incorporation(COI)"
                                ? "Certificate of Incorporation(COI)"
                                : title === "Cancelled Cheque"
                                  ? "Cancelled Cheque"
                                  : title === "Board Resolution"
                                    ? "Board Resolution"
                                    : "other"
            } sheet view button`,
          TransporterName: transporterInfo.transporter_name,
          TransporterId: transporterInfo.transporterId,
          ActivityType: "event_view",
        }
      );
      // onLoaderStateChange();

      Activity([
        {
          screen,
          module: modulename,
          user_activity: `${fileDescription}_view`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);

      setLoading(true); // Set loading to true when starting to view a file
      const signedUrl = await getSignedDownloadUrl(fileId);
      if (!signedUrl) {
        toast.error("Failed to get file for viewing");
        setLoading(false); // If no signed URL, set loading to false
        return;
      }

      if (onViewFile) {
        onViewFile(signedUrl, { title, fileId, fileName, fileDescription, screen, modulename }); // Pass additional context to onViewFile callback
      } else {
        setViewFilePath(signedUrl);
        setViewFile(true);
      }
    } catch (err) {
      console.error("View file failed:", err?.message || err);
      toast.error("Unable to view file");
      setLoading(false); // If an error occurs, set loading to false
    } finally {
      // onLoaderStateChange(); // Keep this for global loader if needed
    }
  };

  const LastUpdated = () => (
    <div
      className={`${classes["last-updated"]} ${lastUpdatedClassName} ${lastUpdated ? "" : classes.hidden
        }`}
    >
      <label>Last Updated {new Date(lastUpdated).toLocaleDateString()}</label>
    </div>
  );

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  return (
    <div className={`${classes.container} ${className}`}>
      {!lastUpdatedAtBottom ? <LastUpdated /> : null}

      <div
        className={`${classes["content-actions"]} ${onUpload ? classes.upload : ""
          }`}
      >
        {fileId && isViewableFile(fileName) ? (
          <Button
            title="View"
            onClick={onViewClick}
            classname={classes.button}
            style={{ width: "62%" }}
          />
        ) : null}

        {fileId ? (
          <Button
            title="Download"
            classname={classes.button}
            onClick={onDownload}
          />
        ) : null}

        {onUpload ? (
          // <div className={classes['file-input-container']}>
          //   <Button title="Upload" style={{ cursor: 'pointer' }} classname={classes.button} />
          //   <input
          //     type="file"
          //     className='d-none'
          //     onChange={onChange}
          //   />
          // </div>
          // className="btn btn-primary upload-file-button-enquiry-my-account"
          <label className={`${classes["upload-input"]}`}>
            <input
              type="file"
              style={{ cursor: "pointer" }}
              onChange={onChange}
              className="d-none"
              accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                text/plain, application/pdf, image/*"
            />
            Upload
          </label>
        ) : null}

        <FileViewer
          viewFile={viewFile}
          setViewFile={setViewFile}
          viewFilePath={viewFilePath}
          fileViewHeader={fileViewHeader}
          fileName={fileName}
          numPages={numPages}
          loading={loading}
          onDocumentLoadSuccess={onDocumentLoadSuccess} // Pass the onDocumentLoadSuccess as a prop
          setLoading={setLoading} // Pass setLoading to FileViewer
        />
      </div>
      {lastUpdatedAtBottom ? <LastUpdated /> : null}
    </div>
  );
};

const validateFile = (file) => {
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "image/jpeg",
    "image/png",
  ];

  if (!allowedTypes.includes(file.type)) {
    toast.warn("Only PDF, Word, or Excel files are allowed");
    return false;
  }
  if (
    file &&
    file.size &&
    file.size < Constants.FileUploadMaxSize * 1024 * 1024
  ) {
    return true;
  } else {
    toast.warn(`Please upload file below ${Constants.FileUploadMaxSize} MB`);
    return false;
  }
};

// const handleCatch = (e, onLoaderStateChange) => {
//   console.log(e);
//   toast.error("Failed to proceed request");
//   onLoaderStateChange && onLoaderStateChange();
// };

const FileViewer = ({
  viewFile,
  setViewFile,
  viewFilePath,
  fileViewHeader,
  fileName = "",
  numPages,
  loading,
  onDocumentLoadSuccess,
  setLoading, // Receive setLoading prop
}) => (
  <Modal
    size="xl"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    show={viewFile}
    onHide={() => {
      setViewFile(false);
      if (setLoading) setLoading(true); // Reset loading state when modal is closed
    }}
    scrollable
    enforceFocus={false}
    autoFocus={false}
    restoreFocus={false}
  >
    <Modal.Header closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        {fileViewHeader}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className={classes["file-viewer-container"]}>
        {loading && (
          <FontAwesomeIcon
            icon={["fas", "spinner"]}
            size="5x"
            spin
            className={classes.loader}
          />
        )}
        {viewFilePath && (
          (fileName || "").endsWith(".pdf") ? (
            <div className={classes["pdf-scroll-container"]} style={{ display: loading ? "none" : "block" }}>
              <Document
                file={viewFilePath}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
              </Document>
            </div>
          ) : (
            <img
              src={viewFilePath}
              alt="File Preview"
              style={{ width: "100%", maxHeight: "500px", objectFit: "contain", display: loading ? "none" : "block" }}
              onLoad={() => { if (setLoading) setLoading(false); }} // Set loading to false on image load
              onError={() => {
                if (setLoading) setLoading(false);
                toast.error("Failed to load image");
              }} // Handle image loading error
            />
          )
        )}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={() => setViewFile(false)}>Close</Button>
    </Modal.Footer>
  </Modal>
);

export { FileViewer };
export default FileHandler;
